<template lang="html">

    <div class="next-prev-wrapper">

        <a href="#" class="container prev">
            <div class="text">
                <p>Prev case</p>
            </div>
            <div class="case-preview">
                <!-- :title="this.previous.info.title"
                :type="this.previous.info.type" -->
                <CardCase
                    :imageLandscape="this.previous.info.imageLandscape"
                    :imagePortrait="this.previous.info.imagePortrait"
                    :url="this.previous.info.url" />
            </div>
        </a>

        <a href="#" class="container next">
            <div class="text">
                <p>Next case</p>
            </div>
            <div class="case-preview">
                <CardCase
                    :title="this.next.info.title"
                    :type="this.next.info.type"
                    :imageLandscape="this.next.info.imageLandscape"
                    :imagePortrait="this.next.info.imagePortrait"
                    :url="this.next.info.url" />
            </div>
        </a>

    </div>

</template>

<script>
import CardCase from '@/components/CardCase'
export default {
    name: 'CaseViewPrevNext',
    components: {
        CardCase
    },
    props: {
        index: Number
    },
    data() {
        return {
            cases: this.$root.$data.cases,
            previous: {},
            next: {},
            isFirst: this.index === 0 ? true : false,
            isLast: this.index === this.$root.$data.cases.length - 1 ? true : false
        }
    },
    methods: {
        fixate() {
            const element = this.$el

            function fixateLoop() {
				requestAnimationFrame(fixateLoop)

				Object.assign(element.style, {
                    transform: `translateY(${window.scrollY}px)`,
                })
            }

            fixateLoop()
        },
    },
    created() {
        this.previous = !this.isFirst ? this.cases[this.index - 1] : this.cases[this.cases.length - 1]
        this.next = !this.isLast ? this.cases[this.index + 1] : this.cases[0]
    },
    mounted() {
        this.fixate()
    }
}
</script>

<style scoped lang="scss">
@import "../scss/globals.scss";

@keyframes slideFromLeft {
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(0%);
    }
}

@keyframes slideFromRight {
    0% {
        transform: translateX(100%);
    }
    100% {
        transform: translateX(0%);
    }
}

$box-width: 33vw;

.next-prev-wrapper {
    transition: transform $transition-scroll;
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;

    text-transform: uppercase;

    display: flex;
    align-items: center;
    justify-content: space-between;

    pointer-events: none;
    @media screen and (max-width: 1024px) {
        display: none;
    }

    a {
        font-weight: bold;
        letter-spacing: .2em;
        font-size: 0.9em;

    }
}

.container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -6.25vh;

    pointer-events: all;


    .text {
        display: flex;
        align-items: center;
        justify-content: center;
        width: $margin1-1;
    }

    p {
        writing-mode: vertical-lr;
        text-orientation: sideways;
        text-shadow: 1px 1px 0px rgba(0,0,0,0.05);
        font-weight: bold;
    }
}

.prev {
    transform: translateX(calc(#{-$box-width} - 1px));
    transition: transform .6s $ease-in-out;
    flex-direction: row-reverse;

    &:hover {
        transform: translateX(0);
    }

    .text {
        animation: slideFromLeft 2s .6s forwards $very-ease-out;
        transform: translateX(-100%);
        p {
            transform: scale(-1);
        }
    }
}

.next {
    transform: translateX(calc(#{$box-width} + 1px));
    transition: transform .6s $ease-in-out;

    &:hover {
        transform: translateX(0);
    }

    .text {
        animation: slideFromRight 2s .6s forwards $very-ease-out;
        transform: translateX(100%);
    }
}

.case-preview {
    box-sizing: border-box;
    width: $box-width;
    padding: $margin2-1 $margin1-1;
    //height: $box-width * 9 / 16;
    background-color: $color-white;
}

</style>
